export const mockChatRooms = [
  {
    id: 'mock-room-sink',
    title: '雑多なアイデアの投げ込み',
    mode: 'input',
    status: 'summarized',
    summaryNoteId: 'mock-note-1',
    createdAt: '2026-05-09T09:00:00+09:00',
    updatedAt: '2026-05-09T09:18:00+09:00',
    lastMessageAt: '2026-05-09T09:18:00+09:00',
  },
  {
    id: 'mock-room-buddy',
    title: 'AIとの対話履歴',
    mode: 'discuss',
    status: 'active',
    summaryNoteId: null,
    createdAt: '2026-05-10T10:00:00+09:00',
    updatedAt: '2026-05-10T10:15:00+09:00',
    lastMessageAt: '2026-05-10T10:15:00+09:00',
  },
  {
    id: 'mock-room-full',
    title: '上限に達したルーム',
    mode: 'input',
    status: 'active',
    summaryNoteId: null,
    createdAt: '2026-05-11T10:00:00+09:00',
    updatedAt: '2026-05-11T10:15:00+09:00',
    lastMessageAt: '2026-05-11T10:15:00+09:00',
  },
];

export const mockMessages = [
  ...Array.from({ length: 20 }, (_, i) => ({
    id: `mock-full-${i}`,
    roomId: 'mock-room-full',
    text: `メッセージ ${i + 1}`,
    mode: 'input',
    source: i % 2 === 0 ? 'user' : 'assistant',
    kind: i % 2 === 0 ? 'raw_note' : 'chat_reply',
    createdAt: new Date(Date.now() - (20 - i) * 60000).toISOString(),
  })),
  {
    id: 'mock-message-1',
    roomId: 'mock-room-sink',
    text: 'Obsidianっぽいグラフビューは欲しいけど、セットアップなしでスマホからすぐ使える形にしたい。',
    mode: 'input',
    source: 'user',
    kind: 'raw_note',
  },
  {
    id: 'mock-message-2',
    roomId: 'mock-room-sink',
    text: 'アルゴトレードの検証メモ、日次でバラバラに残しているから、あとでテーマごとにまとめたい。',
    mode: 'input',
    source: 'user',
    kind: 'raw_note',
  },
  {
    id: 'mock-message-3',
    roomId: 'mock-room-sink',
    text: 'LPは「使う・広げる」を先に見せたい。入れる、整えるはそのあとでいい。',
    mode: 'input',
    source: 'user',
    kind: 'raw_note',
  },
  {
    id: 'mock-message-4',
    roomId: 'mock-room-sink',
    text: 'HintからAssetへの昇格は自動化しすぎない。人間が見ること自体に意味がある。',
    mode: 'input',
    source: 'user',
    kind: 'raw_note',
  },
  {
    id: 'mock-message-5',
    roomId: 'mock-room-sink',
    text: '価格データのタグはあとでSyncに使えるようにしたい。タグ共起で線の濃さを変えるのは良さそう。',
    mode: 'input',
    source: 'user',
    kind: 'raw_note',
  },
  {
    id: 'mock-message-6',
    roomId: 'mock-room-sink',
    text: '「UIが複雑すぎる」は要注意。Sink / Sync / Think の3つに寄せる。',
    mode: 'input',
    source: 'user',
    kind: 'raw_note',
  },
  {
    id: 'mock-message-7',
    roomId: 'mock-room-sink',
    text: '「UIが複雑すぎる」というテーマでNoteまとめしますか？',
    mode: 'input',
    source: 'assistant',
    kind: 'memo_suggestion',
    metadata: {
      generatedBy: 'mock',
      userMessageCount: 5,
    },
  },
  {
    id: 'mock-message-8',
    roomId: 'mock-room-sink',
    text: 'BuddyはSinkではなくThinkに置く。Sinkは雑に入れるだけにしたほうが直感的。',
    mode: 'input',
    source: 'user',
    kind: 'raw_note',
  },
  {
    id: 'mock-message-9',
    roomId: 'mock-room-sink',
    text: 'SettingsはProfile/AccountよりSettingsがよさそう。中にProfileとAccountを入れる。',
    mode: 'input',
    source: 'user',
    kind: 'raw_note',
  },
  {
    id: 'mock-message-10',
    roomId: 'mock-room-sink',
    text: 'スマホではヘッダーのトグルが見切れやすい。アイコン中心にする。',
    mode: 'input',
    source: 'user',
    kind: 'raw_note',
  },
  {
    id: 'mock-message-11',
    roomId: 'mock-room-buddy',
    text: '既存のメモアプリは整理に時間がかかりすぎるのが悩みです。',
    mode: 'discuss',
    source: 'user',
    kind: 'raw_note',
  },
  {
    id: 'mock-message-12',
    roomId: 'mock-room-buddy',
    text: '🤖 その悩み、よく分かります。整理を「後回し」にできるのがSecond Brainの強みですが、具体的にどの工程が一番負担に感じますか？',
    mode: 'discuss',
    source: 'assistant',
    kind: 'chat_reply',
  },
  {
    id: 'mock-message-13',
    roomId: 'mock-room-buddy',
    text: 'タグ付けや分類を考えるところで手が止まってしまいます。',
    mode: 'anti',
    source: 'user',
    kind: 'raw_note',
  },
  {
    id: 'mock-message-14',
    roomId: 'mock-room-buddy',
    text: '⚔️ もし「タグ付け」を完全に廃止したらどうなるでしょうか？検索性の低下というリスクを、AIによる自動抽出でどこまでカバーできるか、あえて極端な構成を考えてみる価値はありそうです。',
    mode: 'anti',
    source: 'assistant',
    kind: 'chat_reply',
    metadata: {
      referencedAssetIds: ['mock-concept-1']
    }
  },
  {
    id: 'mock-message-15',
    roomId: 'mock-room-buddy',
    text: 'テスト用メッセージ: [Asset ID: mock-concept-1] を参照してください。また、未定義の [Asset ID: unknown] や、タイトル付きの [Note ID: mock-note-1, Title: 脳疲労を避けるメモ運用] もテストします。',
    mode: 'discuss',
    source: 'assistant',
    kind: 'chat_reply',
  },
];

export const mockNotes = [
  {
    id: 'mock-note-old-1',
    title: '古い形式のメモ',
    text: 'これは古い形式のメモのテスト用データです',
  },
  {
    id: 'mock-note-1',
    title: '脳疲労を避けるメモ運用',
    summary: 'Rawログ、Note、Hint、Assetを分け、会話中は思考を止めず、あとでNoteまとめ・Hint抽出する方針。',
    body: `## 要点

- 会話中は思考の勢いを優先する
- Rawログは落とさず保存する
- Noteはあとで読める情報落ち回避サマリーにする
- HintはAIが見つけた未承認の仮説として扱う
- Assetはユーザーが採用した知的資産として管理する

## 未決事項

- タグ単位で複数NoteからHintを抽出する導線
- 既存Assetへの統合フロー
- Syncでの見せ方`,
    type: 'chat_summary',
    status: 'linked',
    sourceRoomIds: ['mock-room-sink'],
    sourceMessageIds: ['mock-message-1', 'mock-message-2', 'mock-message-3', 'mock-message-4'],
    relatedConceptIds: ['mock-concept-1'],
    relatedInsightIds: ['mock-insight-1', 'mock-insight-2'],
    tags: ['メモ運用', '脳疲労', 'セカンドブレイン'],
    metadata: {
      summaryCompleteness: 'complete',
      generatedBy: 'mock',
    },
  },
  {
    id: 'mock-note-1-dup',
    title: '脳疲労を避けるメモ運用（複製）',
    summary: '重複テスト用のデータです。',
    body: '重複テスト用のデータです。',
    type: 'chat_summary',
    status: 'inbox',
    sourceRoomIds: ['mock-room-sink'],
    sourceMessageIds: ['mock-message-1'],
    tags: ['メモ運用'],
    metadata: {
      summaryCompleteness: 'complete',
      generatedBy: 'mock',
    },
  },
  {
    id: 'mock-note-2',
    title: 'タグ単位でHint抽出する案',
    summary: '全Note一括ではなく、選択タグを持つNote群から共通パターンを抽出することで、コストと重複を抑える。',
    body: `## 方針

タグを選び、そのタグに紐づくNote / Hint / AssetをまとめてLLMへ渡す。

## 期待する出力

1. 新規Asset候補
2. 既存Assetへの統合候補
3. 追加で確認すべきHint候補`,
    type: 'chat_summary',
    status: 'reviewed',
    sourceRoomIds: ['mock-room-buddy'],
    sourceMessageIds: ['mock-message-11', 'mock-message-12', 'mock-message-13', 'mock-message-14'],
    relatedConceptIds: [],
    relatedInsightIds: ['mock-insight-3'],
    tags: ['タグ', 'Hint抽出'],
    metadata: {
      summaryCompleteness: 'complete',
      generatedBy: 'mock',
      // sourceMode: 'buddy' is legacy (for compatibility)
    },
  },
  {
    id: 'mock-note-partial',
    title: '途切れたNoteのテスト',
    summary: 'まとめが途中で途切れているテスト用Noteです...',
    body: 'まとめが途中で途切れているテスト用Noteです...',
    type: 'chat_summary',
    status: 'inbox',
    sourceRoomIds: ['mock-room-sink'],
    sourceMessageIds: ['mock-message-1'],
    tags: ['テスト'],
    metadata: {
      summaryCompleteness: 'partial',
      generatedBy: 'mock',
    },
  },
];

export const mockLinks = [
  {
    id: 'mock-link-1',
    fromType: 'note',
    fromId: 'mock-note-1',
    toType: 'concept',
    toId: 'mock-concept-1',
    relation: 'source_of',
    strength: 1.0,
    createdBy: 'user',
    acceptedByUser: true,
    ownerUid: 'mock-user-1',
    createdAt: '2026-05-10T10:00:00+09:00',
  },
  {
    id: 'mock-link-2',
    fromType: 'insight',
    fromId: 'mock-insight-2',
    toType: 'concept',
    toId: 'mock-concept-1',
    relation: 'develops',
    strength: 0.9,
    createdBy: 'ai',
    acceptedByUser: false,
    ownerUid: 'mock-user-1',
    createdAt: '2026-05-10T10:05:00+09:00',
  },
];

export const mockInsights = [
  {
    id: 'mock-insight-1',
    title: '整理は会話後に分離したほうがよい',
    summary: 'ユーザーは会話中の整理より、まず思考を止めずに保存し、後段で構造化するワークフローを重視している。',
    kind: 'hint',
    type: 'implicit_knowledge',
    suggestedTargetType: 'stance',
    status: 'suggested',
    confidence: 0.82,
    sourceNoteIds: ['mock-note-1'],
    sourceRoomIds: ['mock-room-sink'],
    sourceMessageIds: ['mock-message-1', 'mock-message-3'],
    relatedConceptIds: [],
    tags: ['メモ運用', '脳疲労'],
  },
  {
    id: 'mock-insight-2',
    title: 'Raw / Note / Hint / Assetの分離',
    summary: '情報の鮮度や承認状態を混ぜないため、Rawログ、メモ、仮説、採用済み知的資産を別レイヤーで扱う。',
    kind: 'hint',
    type: 'synthesis_suggestion',
    suggestedTargetType: 'framework',
    status: 'accepted',
    confidence: 0.9,
    sourceNoteIds: ['mock-note-1'],
    sourceRoomIds: ['mock-room-sink'],
    sourceMessageIds: ['mock-message-1', 'mock-message-2', 'mock-message-3', 'mock-message-4'],
    relatedConceptIds: ['mock-concept-1'],
    tags: ['セカンドブレイン', '設計'],
  },
  {
    id: 'mock-insight-3',
    title: 'タグを処理範囲にする',
    summary: '全体を一括でHint抽出するより、タグごとに対象範囲を絞るほうが、重複とAPIコストを抑えられる。',
    kind: 'hint',
    type: 'synthesis_suggestion',
    suggestedTargetType: 'interest',
    status: 'suggested',
    confidence: 0.76,
    sourceNoteIds: ['mock-note-2'],
    sourceRoomIds: [],
    sourceMessageIds: [],
    relatedConceptIds: [],
    tags: ['タグ', 'Hint抽出'],
  },
  {
    id: 'mock-insight-dup-test',
    title: '思考データの4層モデル',
    summary: '重複検知のテスト用Hintです。',
    kind: 'hint',
    type: 'implicit_knowledge',
    suggestedTargetType: 'framework',
    status: 'suggested',
    confidence: 0.95,
    sourceNoteIds: ['mock-note-1'],
    sourceRoomIds: ['mock-room-sink'],
    sourceMessageIds: [],
    relatedConceptIds: [],
    tags: ['設計'],
  },
  {
    id: 'mock-insight-dup-test-2',
    title: '思考データの4層モデル（別名）',
    summary: '重複検知のテスト用Hintです。タイトルが似ています。',
    kind: 'hint',
    type: 'implicit_knowledge',
    suggestedTargetType: 'framework',
    status: 'suggested',
    confidence: 0.9,
    sourceNoteIds: ['mock-note-1'],
    sourceRoomIds: ['mock-room-sink'],
    sourceMessageIds: [],
    relatedConceptIds: [],
    tags: ['設計'],
  },
  {
    id: 'mock-insight-tag-merge',
    title: 'タグの統合提案',
    summary: '「セカンドブレイン」と「Second Brain」を統合することを提案します。',
    kind: 'proposed_change',
    type: 'tag_merge',
    status: 'suggested',
    confidence: 0.9,
    sourceNoteIds: [],
    sourceRoomIds: [],
    sourceMessageIds: [],
    relatedConceptIds: [],
    tags: ['設計'],
    proposedPatch: {
      oldTag: 'Second Brain',
      newTag: 'セカンドブレイン'
    }
  },
  {
    id: 'mock-insight-note-update',
    title: 'Noteの内容充実化',
    summary: '「脳疲労を避けるメモ運用」のタグが不足しているため追加を提案します。',
    kind: 'proposed_change',
    type: 'note_update',
    targetId: 'mock-note-1',
    status: 'suggested',
    confidence: 0.85,
    sourceNoteIds: ['mock-note-1'],
    sourceRoomIds: [],
    sourceMessageIds: [],
    relatedConceptIds: [],
    tags: ['メモ運用'],
    proposedPatch: {
      tags: ['メモ運用', '脳疲労', 'セカンドブレイン', '生産性']
    }
  }
];

export const mockConcepts = [
  {
    id: 'mock-concept-1',
    title: '思考データの4層モデル',
    body: `## 型

Rawログ、Note、Hint、Assetを分けて扱う。

## 使いどころ

- チャットログをそのまま知識扱いしない
- AIの仮説をユーザー承認前に真実化しない
- 採用済みの判断基準やフレームワークだけをAssetにする`,
    type: 'framework',
    status: 'active',
    maturity: 'growing',
    tags: ['セカンドブレイン', '設計'],
    sourceInsightIds: ['mock-insight-2'],
    sourceNoteIds: ['mock-note-1'],
    sourceRoomIds: ['mock-room-sink'],
    metadata: {
      confidence: 0.9,
      promotedFrom: 'insight',
    },
  },
  {
    id: 'mock-concept-1-dup',
    title: '思考データの4層モデル(Duplicate)',
    body: '重複テスト用Asset',
    type: 'framework',
    status: 'active',
    maturity: 'seed',
    tags: ['セカンドブレイン', '設計'],
    sourceInsightIds: ['mock-insight-2'],
    sourceNoteIds: ['mock-note-1'],
    sourceRoomIds: ['mock-room-sink'],
    metadata: {
      confidence: 0.8,
      promotedFrom: 'insight',
    },
  },
];
